import { Stack } from "@mui/material";
import BidListingTable from "../Bids/BidListingTable";

const BiddingSection = ({
  jrData,
  bidDetails,
  newChat,
  setBidDetailsModal,
  setCurrentBid,
  mobileView,
}) => (
  <>
    {(jrData.assign_vendor_id === null || jrData.assign_vendor_id !== null) && (
      <Stack direction="row" justifyContent="space-between" width="100%">
        {jrData.job_status === "Bidding" && (
          <Stack>
            <BidListingTable
              bidDetails={bidDetails}
              newChat={newChat}
              setBidDetailsModal={setBidDetailsModal}
              setCurrentBid={setCurrentBid}
              mobileView={mobileView}
            />
          </Stack>
        )}
      </Stack>
    )}
  </>
);

export default BiddingSection;
